import styled from 'styled-components'
import Downarrow from '@/src/assets/svgs/downarrow'
import { getDropdownArrowStyles } from '../style'
import { DropdownArrowProps } from '../type'

const StyledDropdownArrow = styled(Downarrow).withConfig({
    shouldForwardProp: (prop) => !['isOpen'].includes(prop)
})<DropdownArrowProps>`
    ${getDropdownArrowStyles}
`

export default StyledDropdownArrow
